import clsx from 'clsx'
import React from 'react'

const OptionItem = ({ onSelect, name, active }) => {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={clsx('dome-btn dome-btn-base', active ? 'dome-btn-dark-green' : 'dome-btn-grey-stroke')}
    >
      {name}
    </button>
  )
}

const SegmentedControls = ({
  label = 'define when this field is clickable.',
  options,
  selectedOption,
  onOptionSelect,
}) => {
  return (
    <div className="dome-d-flex dome-flex-column">
      <span className="dome-p3 dome-color-med-grey">{label}</span>
      <div
        style={{
          gap: '6px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(89px, 1fr))',
        }}
      >
        {options?.map((option) => (
          <OptionItem
            key={option}
            name={option}
            active={option === selectedOption}
            onSelect={() => onOptionSelect(option)}
          />
        ))}
      </div>
    </div>
  )
}

export default SegmentedControls
